import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./Component/Header";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import styles from "./App.module.css";
import Home from "./pages/Home";
import Footer from "./Component/Footer";
import ImageToJPG from "./features/ImageToJPG";
import ImageToPNG from "./features/ImageToPNG";
import ImageToWebP from "./features/ImageToWebP";
import ImageCompressorCropper from "./features/ImageCompressorCropper";
import ImageConverter from "./features/BatchProcessing";
import BatchProcessing from "./features/BatchProcessing";
import BulkImageCompressor from "./features/BulkImageCompressor";

const App = () => {
  return (
    <Router>
      <div className={styles.app}>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/image-to-jpg" element={<ImageToJPG />} />
          <Route path="/image-to-png" element={<ImageToPNG />} />
          <Route path="/image-to-webp" element={<ImageToWebP />} />
          <Route
            path="/image-crop-compress"
            element={<ImageCompressorCropper />}
          />
          <Route path="//batch-processing" element={<BatchProcessing />} />
          <Route path="/bulk-compressor" element={<BulkImageCompressor />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
